bcn.closeStatusHeader = (function () {

  'use strict';

  return {
    init: function () {

      $('[data-close-status-header]').on('click', function () {
        $(this).parents('.status-header').addClass('hidden');
        $('.header').removeClass('hidden');
      });

    }
  };
})();
